import script from "./RingingCallsContainer.vue?vue&type=script&setup=true&lang=ts"
export * from "./RingingCallsContainer.vue?vue&type=script&setup=true&lang=ts"

import "./RingingCallsContainer.vue?vue&type=style&index=0&id=006181ca&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-006181ca"]])

export default __exports__